import * as lodash from '../utils/lodash';
export function getAlignPosition(start, end, size, align) {
    var positionMap = {
        start: start,
        end: end - size,
        center: (start + end) / 2 - size / 2,
    };
    return positionMap[align];
}
export function flexLayout(contentBox, boxList, type, propsAlign, propsPack) {
    if (propsAlign === void 0) { propsAlign = 'start'; }
    if (propsPack === void 0) { propsPack = 'start'; }
    var left = contentBox.x;
    var right = contentBox.x + contentBox.width;
    var top = contentBox.y;
    var bottom = contentBox.y + contentBox.height;
    function boxAlign(axis, align) {
        boxList.forEach(function (box) {
            if (axis === 'x') {
                box.x = getAlignPosition(left, right, box.width, align);
            }
            else if (axis === 'y') {
                box.y = getAlignPosition(top, bottom, box.height, align);
            }
        });
    }
    function boxPack(axis, pack) {
        var contentSize = axis === 'x'
            ? lodash.sum(boxList.map(function (box) { return box.width; }))
            : lodash.sum(boxList.map(function (box) { return box.height; }));
        var start = axis === 'x'
            ? getAlignPosition(left, right, contentSize, pack)
            : getAlignPosition(top, bottom, contentSize, pack);
        boxList.reduce(function (prev, current) {
            if (axis === 'x') {
                current.x = prev;
                return prev + current.width;
            }
            if (axis === 'y') {
                current.y = prev;
                return prev + current.height;
            }
        }, start);
    }
    if (type === 'hbox') {
        boxPack('x', propsPack);
        boxAlign('y', propsAlign);
    }
    else if (type === 'vbox') {
        boxPack('y', propsPack);
        boxAlign('x', propsAlign);
    }
}
export function getPadding(padding) {
    var paddingTop = 0;
    var paddingLeft = 0;
    var paddingRight = 0;
    var paddingBottom = 0;
    if (lodash.isNumber(padding)) {
        paddingTop = paddingLeft = paddingRight = paddingBottom = padding;
    }
    else if (lodash.isArray(padding)) {
        if (padding.length === 1) {
            paddingTop = paddingLeft = paddingRight = paddingBottom = padding[0];
        }
        else if (padding.length === 2) {
            paddingTop = paddingBottom = padding[0];
            paddingLeft = paddingRight = padding[1];
        }
        else if (padding.length === 3) {
            paddingTop = padding[0];
            paddingRight = paddingLeft = padding[1];
            paddingBottom = padding[2];
        }
        else if (padding.length === 4) {
            paddingTop = padding[0];
            paddingRight = padding[1];
            paddingBottom = padding[2];
            paddingLeft = padding[3];
        }
    }
    return {
        paddingTop: paddingTop,
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
        paddingBottom: paddingBottom,
    };
}
